import { useState } from "react";
import { Button, Menu, MenuItem, Checkbox } from "@mui/material";
import { Tune } from "@mui/icons-material";
import { FilterOption, ActiveFilter } from "../types";

interface FilterMenuProps<T extends ActiveFilter> {
	availableFilters: FilterOption[];
	extraFilters: T[];
	onChange: (filters: T[]) => void;
}

export default function FilterMenu<T extends ActiveFilter>({
	availableFilters,
	extraFilters,
	onChange,
}: FilterMenuProps<T>) {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) =>
		setAnchorEl(event.currentTarget);
	const handleClose = () => setAnchorEl(null);

	const toggleFilter = (filter: FilterOption) => {
		const isActive = extraFilters.some((f) => f.key === filter.key);

		if (isActive) {
			onChange(extraFilters.filter((f) => f.key !== filter.key));
		} else {
			onChange([
				...extraFilters,
				{ key: filter.key, label: filter.label, value: filter.values[0].value } as T,
			]);
		}
	};

	return (
		<>
			<Button variant="contained" onClick={handleOpen} startIcon={<Tune />}>
				Filtros
			</Button>

			<Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
				{availableFilters.map((filter) => {
					const isActive = extraFilters.some((f) => f.key === filter.key);
					return (
						<MenuItem key={filter.key} onClick={() => toggleFilter(filter)}>
							<Checkbox checked={isActive} />
							{filter.label}
						</MenuItem>
					);
				})}
			</Menu>
		</>
	);
}
